<template>
    <section class="form-standard">
        <article class="row">
                <div class="tabs-container">
                    <nav class="tabs">
                        <ul :class="{ 'prevent-others': !isEditing() }">
                            <li class="back"><RouterLink :to="addQueryString(cancelLink)" title="Voltar"><i class="bi bi-arrow-90deg-left"></i></RouterLink></li>
                            <li v-for="(tab, key) in tabs" :key="key">
                                <a :href="'#' + key" :class="{ selected: selectedTab === key, modified: modifiedData[key]['is_modified'] && selectedTab !== key }" @click="selectTab(key)">
                                    <i :class="`bi bi-${tab.icon}`" v-if="tab.icon"></i>
                                    {{ tab.label }}
                                    <span class="warning">
                                        <i class="bi bi-exclamation-triangle-fill"></i> <span>Alterações não aplicadas</span>
                                    </span>
                                </a>
                            </li>
                            <li class="actions">
                                <button class="btn rounded-small medium outline blue" type="button" :disabled="isLoading" v-if="hasModifiedFields()" @click="submitAllModifiedForms()" ref="applyAll"><i class="bi bi-check2-square"></i>Aplicar todas as alterações</button>
                            </li>
                        </ul>
                    </nav>
                    <div class="containers">
                        <div class="container" v-for="(tab, key) in tabs" :key="key" v-show="selectedTab === key">
                            <form @submit.prevent="handleSubmit(key, $event)" autocomplete="off" :ref="el => formRefs[key] = el">
                                <div class="columns">
                                    <component
                                        v-for="(field, fieldkey) in tab.fields"
                                        :is="getTypeofComponent(field.type)"
                                        :key="fieldkey"
                                        :type="field.type"
                                        :label="field.label"
                                        :name="fieldkey"
                                        :value="data[fieldkey]"
                                        :class="`${field.class} bg black ${isLoading ? 'loading' : ''} ${modifiedData[key] ? (modifiedData[key]['fields'][fieldkey] ? 'modified' : '') : ''} ${isFieldRequired(field) ? 'required' : ''} ${errorFields[key] && errorFields[key][fieldkey] && errorFields[key][fieldkey].length > 0 ? 'error' : ''}`"
                                        :tip="field.tip"
                                        :mask-type="field.maskType"
                                        :placeholder="field.placeholder"
                                        :maxlength="field.maxlength"
                                        :options="field.type === 'select' ? field.options : undefined"
                                        :api="field.api"
                                        :disabled="isLoading"
                                        :required="isFieldRequired(field) ? 'required' : null"
                                        :error="errorFields[key] && errorFields[key][fieldkey] ? errorFields[key][fieldkey] : null"
                                        @value-updated="updateValue"
                                    />
                                </div>
                                <div class="actions">
                                    <button class="btn rounded-small medium transparent yellow" type="button" v-if="hasModifiedFields(key) && isEditing()" @click="resetForm(key)"><i class="bi bi-backspace-fill"></i>Reverter Alterações</button>
                                    <div class="divider"></div>
                                    <button class="btn rounded-medium big outline blue" type="submit" ref="applyButton" :disabled="!hasModifiedFields(key)" :data-key="key" v-if="!hasNextTab()"><i class="bi bi-check2-square"></i>Aplicar</button>
                                    <button class="btn rounded-medium big transparent" type="button" ref="nextButton" v-if="hasNextTab() && !hasModifiedFields(key)" @click.prevent="nextTab()"><i class="bi bi-arrow-bar-right"></i> Próximo</button>
                                    <button class="btn rounded-medium big outline green" type="submit" ref="saveButton" :disabled="!hasModifiedFields(key)" :data-key="key" v-if="!hasModifiedFields(key, true)"><i class="bi bi-save"></i>Salvar</button>
                                </div>
                                <AlertComponent
                                    :type="alertType[key]"
                                    :message="alertMessage[key]"
                                    @close="alertMessage[key] = null"
                                />
                            </form>
                        </div>
                    </div>
                </div>
                <legend>
                    <h4>Legenda:</h4>
                    <div class="items">
                        <div class="legend-item" v-if="hasLegend('required')"><i class="bi bi-asterisk info"></i> Campos Obrigatórios</div>
                        <div class="legend-item" v-if="hasLegend('modified')"><i class="bi bi-pencil-square warning"></i> Campos Alterados</div>
                        <div class="legend-item" v-if="hasLegend('error')"><i class="bi bi-x-octagon error"></i> Campos com Erros</div>
                    </div>
                </legend>
        </article>
    </section>
</template>

<script>
import axios from '@/store/axios';
import AlertComponent from '@/components/general/AlertComponent.vue';

export default {
    name: 'FormComponent',
    components: {
        AlertComponent,
    },
    props: {
        tabs: {
            type: Object,
            required: true
        },
        cancelLink: {
            type: String,
            default: '/'
        },
        apiUrl: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            selectedTab: Object.keys(this.tabs)[0],
            data: this.initializeData(),
            dataTabs: this.initializeDataTabs(),
            originalData: {},
            modifiedData: this.initializeModifiedData(),
            alertMessage: {},
            alertType: {},
            id: null,
            isLoading: true,
            formRefs: {},
            haveBeenApplied: false,
            errorFields: {},
        };
    },
    mounted() {
        this.id = this.$route.query.id;
        this.selectDefaultTab();
        this.updateOriginalData();
        if (this.id) {
            const apiUrl = this.apiUrl;
            // setTimeout(() => {
                axios.get(`${apiUrl}/${this.id}`)
                .then(response => {
                    const data = response.data.data;
                    this.data = Object.keys(data).reduce((acc, key) => {
                        let fieldFound = null;
                        Object.values(this.tabs).forEach(tab => {
                            if (tab.fields[key]) {
                                fieldFound = tab.fields[key];
                            }
                        });
                        if (fieldFound && fieldFound.path) {
                            const pathParts = fieldFound.path.split('.');
                            let value = data;
                            for (const part of pathParts) {
                                if (value && value.hasOwnProperty(part)) {
                                    value = value[part];
                                } else {
                                    value = null;
                                    break;
                                }
                            }
                            acc[key] = value !== null ? String(value) : '';
                        } else {
                            acc[key] = String(data[key]);
                        }
                        return acc;
                    }, {});
                    this.updateOriginalData(); // Salva os valores originais
                    this.isLoading = false;
                })
                .catch(error => {
                    this.alertMessage[this.selectedTab] = 'Erro ao carregar os dados: ' + error?.response?.data?.status?.message || 'Erro desconhecido';
                    this.alertType[this.selectedTab] = 'error';
                });
            // }, 150);
        }
        else {
            this.isLoading = false;
        }
    },
    methods: {
        isEditing() {
            return this.$route.query.id ? true : false; // Verifica se está editando ou criando um novo registro
        },
        updateOriginalData() {
            this.originalData = JSON.parse(JSON.stringify(this.data)); // Salva os valores originais
            // Define "0" como padrão para checkboxes com valor vazio
            Object.keys(this.originalData).forEach(key => {
                const field = this.dataTabs[key] && this.tabs[this.dataTabs[key]].fields[key];
                if (field && field.type === 'checkbox' && this.originalData[key] === '') {
                    this.originalData[key] = "0";
                }
            });
        },
        initializeDataTabs() {
            const dataTabs = {};
            Object.entries(this.tabs).forEach(([tabKey, tab]) => {
                Object.keys(tab.fields).forEach(key => {
                    dataTabs[key] = tabKey;
                });
            });
            return dataTabs;
        },
        initializeData() {
            const initialData = {};
            Object.values(this.tabs).forEach(tab => {
                Object.keys(tab.fields).forEach(key => {
                    if(this.isEditing()){
                        initialData[key] = '';
                    }
                    else{
                        initialData[key] = tab.fields[key].value || tab.fields[key].default || ''; // Inicializa com valor padrão ou vazio
                    }
                });
            });
            return initialData;
        },
        initializeModifiedData() {
            return Object.keys(this.tabs).reduce((acc, tabKey) => {
                acc[tabKey] = {
                    is_modified: false, // Inicializa como não modificado
                    fields: Object.keys(this.tabs[tabKey].fields).reduce((fieldAcc, fieldKey) => {
                        fieldAcc[fieldKey] = false; // Inicializa cada campo como não modificado
                        return fieldAcc;
                    }, {})
                };
                return acc;
            }, {});
        },
        updateValue(field){
            const tabKey = this.dataTabs[field.key];
            if (field.type === 'checkbox') {
                this.data[field.key] = field.value ? "1" : "0"; // Converte para string "1" ou "0"
            }
            else{
                this.data[field.key] = field.value;
            }
            if (tabKey) {
                if (this.errorFields[tabKey] && this.errorFields[tabKey][field.key]) {
                    this.errorFields[tabKey][field.key] = null; // Limpa o campo de erro
                }
                if (!this.modifiedData[tabKey]['fields'][field.key] && this.data[field.key] !== (this.originalData[field.key]??'')) {
                    this.haveBeenApplied = false;
                    this.modifiedData[tabKey]['is_modified'] = true; // Marca o tab como modificado
                    this.modifiedData[tabKey]['fields'][field.key] = true; // Marca o campo como modificado
                }
                else if (this.modifiedData[tabKey]['fields'][field.key] && this.data[field.key] === (this.originalData[field.key]??'')) {
                    this.modifiedData[tabKey]['fields'][field.key] = false; // Marca o campo como não modificado
                    const allFieldsUnmodified = Object.values(this.modifiedData[tabKey]['fields']).every(field => !field);
                    this.modifiedData[tabKey]['is_modified'] = !allFieldsUnmodified; // Atualiza o estado do tab
                }
            }
        },
        clearModifiedFields(tabKey) {
            if (this.modifiedData[tabKey]) {
                this.modifiedData[tabKey]['is_modified'] = false; // Marca o tab como não modificado
                Object.keys(this.modifiedData[tabKey]['fields']).forEach(fieldKey => {
                    this.modifiedData[tabKey]['fields'][fieldKey] = false; // Marca todos os campos como não modificados
                });
            }
        },
        updateModifiedFields(tabKey) {
            const tabFields = Object.keys(this.tabs[tabKey].fields);
            this.originalData = {
                ...this.originalData,
                ...tabFields.reduce((acc, fieldKey) => {
                    acc[fieldKey] = this.data[fieldKey];
                    return acc;
                }, {})
            };
            this.clearModifiedFields(tabKey); // Limpa os campos modificados
        },
        hasModifiedFields(tabKey = null, otherTabKeys = false) {
            if(this.isLoading){
                return false; // Não verifica se está editando e carregando
            }
            if (otherTabKeys) {
                return Object.keys(this.modifiedData).some(otherTabKey => 
                    otherTabKey !== tabKey && this.modifiedData[otherTabKey]['is_modified']
                );
            }
            if (tabKey) {
                return this.modifiedData[tabKey] ? this.modifiedData[tabKey]['is_modified'] : false;
            }
            // Se não for passado um tabKey, verifica se algum tab tem campos modificados
            return Object.keys(this.modifiedData).some(key => this.modifiedData[key]['is_modified']);
        },
        handleSubmit(key, event) {
            if(this.isLoading) return;

            this.errorFields[key] = null; // Limpa os campos de erro

            // Verifica qual botão foi clicado
            const clickedButton = event?.submitter;
            const isApplyAll = this.$refs.applyAll === clickedButton;
            const isApplyButton = this.$refs.applyButton === clickedButton ||
                      (Array.isArray(this.$refs.applyButton) && this.$refs.applyButton.includes(clickedButton));

            if(this.apiUrl){
                const form = this.formRefs[key];
                const apiUrl = this.apiUrl;
                const payload = Object.keys(this.tabs[key].fields).reduce((acc, fieldKey) => {
                    acc[fieldKey] = this.data[fieldKey];
                    if (this.tabs[key].fields[fieldKey].type === 'checkbox' && !this.data[fieldKey]) {
                        acc[fieldKey] = "0";
                    }
                    // else if (this.tabs[key].fields[fieldKey].type === 'avatar' && this.data[fieldKey] && this.data[fieldKey].blob) {
                    //     acc[fieldKey] = this.data[fieldKey].blob;
                    // }
                    return acc;
                }, {});

                // adiciona os valores padrão dos campos que não foram preenchidos de outras abas
                if(!this.isEditing()){
                    Object.keys(this.tabs).forEach(tabKey => {
                        Object.entries(this.tabs[tabKey].fields).forEach(([fieldKey, field]) => {
                            if (field.default && !payload[fieldKey]) {
                                payload[fieldKey] = field.default;
                            }
                        });
                    });
                }
                // console.log('payload', payload);
                // return; // Para evitar chamadas desnecessárias

                this.toggleSending(false, clickedButton);

                const method = this.id ? 'put' : 'post';
                const url = this.id ? `${apiUrl}/${this.id}` : apiUrl;

                // setTimeout(() => {
                    axios[method](url, payload)
                    .then(response => {
                        this.updateModifiedFields(key); // Limpa os campos modificados após o sucesso
                        if (isApplyButton || isApplyAll) {
                            // Apenas aplica as alterações e permanece na página
                            this.alertMessage[key] = 'Alterações aplicadas com sucesso!';
                            this.alertType[key] = 'success';
                            this.toggleSending(true, clickedButton);
                            this.haveBeenApplied = true; // Marca que as alterações foram aplicadas
                            if (!this.isEditing()){
                                const new_id = response.data?.data?.id;
                                this.id = new_id;
                                if (!new_id) {
                                    this.$router.push(this.addQueryString(this.cancelLink));
                                }
                                this.$router.push({ path: this.$route.path, query: { id: new_id } });
                            }
                        } else {
                            // Redireciona para a página de cancelLink se o botão "Salvar" foi clicado
                            this.$router.push(this.addQueryString(this.cancelLink));
                        }
                    })
                    .catch(error => {
                        const status = error.response?.data?.status || { message: 'Ocorreu um erro desconhecido' };
                        const tabKey = key;
                        this.selectedTab = tabKey; // Seleciona a aba atual em caso de erro
                        this.errorFields[tabKey] = {};
                        if (status?.details) {
                            Object.keys(status.details).forEach(key => {
                                this.errorFields[tabKey][key] = [];
                                const fieldErrors = status.details[key];
                                fieldErrors.forEach(err => {
                                    this.errorFields[tabKey][key].push(err);
                                    // this.alertMessage[tabKey] += `\n${err}`;
                                });
                            });
                        }
                        else{
                            this.alertMessage[tabKey] = status?.message;
                            this.alertType[tabKey] = 'error';
                        }
                        this.toggleSending(true, clickedButton);
                    });
                // }, 150);
            }
            return;
        },
        getTypeofComponent(type) {
            switch (type) {
                case 'select':
                    return 'SelectField';
                case 'checkbox':
                    return 'CheckboxField';
                case 'avatar':
                    return 'AvatarField';
                default:
                    return 'InputField';
            }
        },
        toggleSending(remove = false, clickedButton = null) {
            if(!remove) {
                const dataKey = clickedButton?.getAttribute('data-key');
                if(dataKey) {
                    this.alertMessage[dataKey] = null;
                }
                else {
                    this.alertMessage = {};
                }
            }
            const saveButtons = Array.isArray(this.$refs.saveButton) ? this.$refs.saveButton : [this.$refs.saveButton];
            const applyButtons = Array.isArray(this.$refs.applyButton) ? this.$refs.applyButton : [this.$refs.applyButton];
            const applyAll = this.$refs.applyAll;
            const buttons = [...saveButtons, ...applyButtons, applyAll];
            buttons.forEach(button => {
                if (button && button.classList) {
                    if (remove) {
                        button.classList.remove('loading');
                        button.disabled = false;
                    } else {
                        if (button === clickedButton) {
                            button.classList.add('loading');
                        }
                        button.disabled = true;
                    }
                }
            });
        },
        resetForm(key) {
            const tabFields = Object.keys(this.tabs[key].fields);
            tabFields.forEach(fieldKey => {
                // console.log(fieldKey, this.data[fieldKey], this.originalData[fieldKey]);
                this.data[fieldKey] = this.originalData[fieldKey]; // Restaura os dados originais apenas da aba atual
            });
            this.clearModifiedFields(key); // Limpa os campos modificados
            this.formRefs[key].reset(); // Reseta o formulário     
        },
        selectTab(key) {
            if (this.isEditing() || key === Object.keys(this.tabs)[0]) {
                this.selectedTab = key;
                this.haveBeenApplied = false;
            }
            else {
                return false; // Não permite selecionar a aba se não estiver editando e não for a primeira aba
            }
        },
        selectDefaultTab() {
            if (!this.isEditing()){
                return; // Não faz nada se não estiver editando
            }
            const hash = this.$route.hash.replace('#', '');
            if (hash && this.tabs[hash]) {
                this.selectedTab = hash;
            } else {
                this.selectedTab = Object.keys(this.tabs)[0]; // Seleciona a primeira aba por padrão
            }
        },
        submitAllModifiedForms() {
            const modifiedTabs = Object.keys(this.modifiedData).filter(key => this.modifiedData[key]['is_modified']);
            const firstTab = modifiedTabs[0];
            let selectedTabIsModified = false;
            modifiedTabs.forEach(tabKey => {
                if (this.selectedTab === tabKey) {
                    selectedTabIsModified = true;
                }
                const form = this.formRefs[tabKey];
                if (form) {
                    this.handleSubmit(tabKey, { submitter: this.$refs.applyAll });
                }
            });
            if (!selectedTabIsModified) {
                this.selectedTab = firstTab; // Se a aba atual não estiver modificada, muda para a primeira aba modificada
            }
        },
        hasLegend(type) {
            const current_tab = this.selectedTab;
            switch (type) {
                case 'required':
                    return Object.values(this.tabs[current_tab].fields).some(field => field.required);
                case 'modified':
                    return this.modifiedData[current_tab]?.is_modified || false;
                case 'error':
                    return Object.keys(this.errorFields[current_tab] || {}).some(fieldKey => 
                        this.errorFields[current_tab][fieldKey] && this.errorFields[current_tab][fieldKey].length > 0
                    );
                default:
                    return false;
            }
        },
        isFieldRequired(field) {
            if (typeof field.required === 'boolean') {
                return field.required ? true : false;
            } else if (typeof field.required === 'string') {
                return (field.required === 'add' && !this.isEditing()) || (field.required === 'edit' && this.isEditing());
            }
            return false;
        },
        hasNextTab() {
            if(!this.haveBeenApplied){
                return false;
            }
            const currentTabIndex = Object.keys(this.tabs).indexOf(this.selectedTab);
            return currentTabIndex < Object.keys(this.tabs).length - 1;
        },
        nextTab() {
            const currentTabIndex = Object.keys(this.tabs).indexOf(this.selectedTab);
            if (currentTabIndex < Object.keys(this.tabs).length - 1) {
                this.selectedTab = Object.keys(this.tabs)[currentTabIndex + 1];
            }
        },
        decodeQueryString(encodedString) {
            const decodedString = atob(encodedString);
            const params = new URLSearchParams(decodedString);
            const query = Object.fromEntries(params.entries());
            return query;
        },
        addQueryString(url) {
            const queryString = this.decodeQueryString(this.$route.query.query || '');
            const queryParams = new URLSearchParams(queryString).toString();
            if (url.includes('#')) {
                const [baseUrl, hash] = url.split('#');
                const separator = baseUrl.includes('?') ? '&' : '?';
                return `${baseUrl}${separator}${queryParams}#${hash}`;
            } else if (url.includes('?')) {
                return `${url}&${queryParams}`;
            } else {
                return `${url}?${queryParams}`;
            }
        },
    }
};
</script>

<style scoped src="@/assets/css/general/form-style.css"></style>
<style scoped src="@/assets/css/general/tab-style.css"></style>